<template>
    <div v-on-clickaway="away">
        <div class="colour-picker">
            <a href="#" class="colour-picker__button"
                @click.prevent="toggleDropdown()"
                v-bind:style="{ borderColor: tracked_colour.hex }">
                {{ name }}
            </a>

            <div class="colour-picker__display"
                 v-bind:style="{ backgroundColor: tracked_colour.hex }">

            </div>

<!--            <a href="#" -->
<!--                class="colour-picker__toggle"-->
<!--                @click.prevent="toggleDropdown()">-->

<!--                <span class="colour-picker__display" -->
<!--                    v-bind:style="{ backgroundColor: tracked_colour.hex }"></span>-->

<!--                <span class="align-middle">-->
<!--                    {{ name }}-->
<!--                </span>-->
<!--            </a>-->

            <div v-show="show_dropdown" class="dropdown">
                <colour-picker v-model="tracked_colour"></colour-picker>
            </div>
        </div>
    </div>
</template>

<script>
    import { Chrome as ColourPicker } from 'vue-color';
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        components: {
            ColourPicker
        },

        mixins: [
            clickaway
        ],

        props: ['name', 'colour'],

        data() {
            return {
                show_dropdown: false,
                tracked_colour: {
                    hex: '#ffffff'
                }
            }
        },

        watch: {
            tracked_colour() {
                this.$emit("colour-picked", this.tracked_colour.hex);
            },

            colour(colour) {
                this.tracked_colour.hex = colour;
            }
        },

        methods: {
            toggleDropdown() {
                this.show_dropdown = !this.show_dropdown;
            },

            away() {
                this.show_dropdown = false;
            }
        },

        created() {
            this.tracked_colour.hex = this.colour;
        }
    }
</script>

<style scoped lang="scss">
    .colour-picker {
        position: relative;

        &__button {
            @include font-h3;
            border: 1px solid $color-white;
            display: inline-block;
            width: 100%;
            background-color: transparent;
            border-radius: 30px;
            text-align: center;
            color: $color-white;
            padding: 0.5rem;

            &:hover {
                color: $color-white;
            }
        }

        &__display {
            position: absolute;
            left: 0;
            top: 0;
            bottom: 0;
            width: 50px;
            border-radius: 30px 0 0 30px;
        }

        &__toggle {
            display: inline-block;
            color: black;
            text-decoration: none;

            span {
                vertical-align: middle;
            }
        }

        //&__display {
        //    width: 30px;
        //    height: 30px;
        //    border: 1px solid rgba(black, 0.3);
        //    display: inline-block;
        //    margin-right: 4px;
        //    border-radius: 20px;
        //}
    }

    .dropdown {
        position: absolute;
        top: 35px;
        z-index: 9;
    }

    .vc-chrome {
        width: 250px;
    }
</style>